(function(){
  document.querySelectorAll('[data-wr-stage]').forEach(function(stage){
    var slides=[].slice.call(stage.querySelectorAll('[data-wr-slide]'));
    if(slides.length<2) return;
    var delay=+stage.getAttribute('data-wr-interval')||5000;
    var bar=stage.querySelector('[data-wr-progress]');
    var prev=stage.querySelector('[data-wr-prev]'), next=stage.querySelector('[data-wr-next]');
    var reduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i=0, timer=null, hover=false;
    function warm(n){ var img=slides[n].querySelector('img[loading="lazy"]'); if(img) img.loading='eager'; }
    function setActive(n){
      var old=slides[i];
      old.classList.remove('is-active'); old.setAttribute('aria-hidden','true');
      old.querySelectorAll('a').forEach(function(a){ a.setAttribute('tabindex','-1'); });
      i=(n+slides.length)%slides.length;
      var cur=slides[i];
      cur.classList.add('is-active'); cur.removeAttribute('aria-hidden');
      cur.querySelectorAll('a').forEach(function(a){ a.removeAttribute('tabindex'); });
      warm((i+1)%slides.length); warm((i-1+slides.length)%slides.length);
    }
    function restartBar(){ if(!bar) return; bar.classList.remove('is-running'); void bar.offsetWidth; bar.classList.add('is-running'); }
    function stopBar(){ if(bar) bar.classList.remove('is-running'); }
    function running(){ return !reduced && !hover && !document.hidden; }
    function schedule(){ clearTimeout(timer); if(!running()){ stopBar(); return; } restartBar(); timer=setTimeout(function(){ setActive(i+1); schedule(); }, delay); }
    function go(n){ setActive(n); schedule(); }
    warm(1); warm(slides.length-1);
    if(prev) prev.addEventListener('click',function(){ go(i-1); });
    if(next) next.addEventListener('click',function(){ go(i+1); });
    stage.addEventListener('mouseenter',function(){ hover=true; schedule(); });
    stage.addEventListener('mouseleave',function(){ hover=false; schedule(); });
    document.addEventListener('visibilitychange',schedule);
    document.addEventListener('keydown',function(e){
      if(e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      var t=e.target; if(t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      if(e.key==='ArrowRight'){ e.preventDefault(); go(i+1); }
      else if(e.key==='ArrowLeft'){ e.preventDefault(); go(i-1); }
    });
    schedule();
  });
  var btns=[].slice.call(document.querySelectorAll('[data-wr-media-btn]'));
  var items=[].slice.call(document.querySelectorAll('[data-wr-media-item]'));
  btns.forEach(function(b){ b.addEventListener('click',function(){ var n=+b.getAttribute('data-wr-media-btn'); items.forEach(function(it,k){ it.hidden=(k!==n); }); btns.forEach(function(x,k){ x.setAttribute('aria-pressed', k===n ? 'true' : 'false'); }); }); });
  var vEl=document.querySelector('[data-wr-variants]');
  var form=document.querySelector('.wr-form');
  if(!vEl || !form) return;
  var variants=JSON.parse(vEl.textContent);
  var idInput=form.querySelector('[data-wr-variant-id]');
  var price=document.querySelector('[data-wr-price]');
  var add=form.querySelector('[data-wr-add]');
  var fmt;
  try { fmt=new Intl.NumberFormat('en-PH',{style:'currency',currency:vEl.getAttribute('data-currency')||'PHP'}); } catch(err) { fmt=null; }
  form.addEventListener('change',function(e){
    var t=e.target;
    if(!t.hasAttribute('data-wr-option-index')) return;
    var idx=t.getAttribute('data-wr-option-index');
    var lbl=document.querySelector('[data-wr-option-value="'+idx+'"]');
    if(lbl) lbl.textContent=t.value;
    var sel=[];
    form.querySelectorAll('fieldset.wr-option').forEach(function(fs,k){ var c=fs.querySelector('input:checked'); sel[k]=c ? c.value : null; });
    var v=null;
    for(var j=0;j<variants.length;j++){ var ok=true; for(var k=0;k<sel.length;k++){ if(variants[j].options[k]!==sel[k]){ ok=false; break; } } if(ok){ v=variants[j]; break; } }
    if(!v){ add.disabled=true; add.textContent='Unavailable'; return; }
    idInput.value=v.id;
    if(price) price.textContent= fmt ? fmt.format(v.price/100) : (v.price/100).toFixed(2);
    add.disabled=!v.available;
    add.textContent= v.available ? 'Add to cart' : 'Sold out';
    try { var url=new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({},'',url.toString()); } catch(err) {}
  });
})();
